var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper active",
      staticStyle: { display: "block" },
      attrs: { tabindex: "0" }
    },
    [
      _c(
        "div",
        {
          ref: "layerBox",
          staticClass: "cbox layerBox popWidM",
          style: Object.assign(
            {},
            { display: "block", opacity: "1" },
            _vm.style
          )
        },
        [
          _c("div", { staticClass: "cart-popup__dialog pf23-itemAgreePop" }, [
            _vm.showHeader
              ? _c("div", { staticClass: "cart-popup__header" }, [
                  _c(
                    "span",
                    {
                      staticClass: "cart-popup__header-text",
                      staticStyle: { color: "#2c2c2c" }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.headerText) + "\n          "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "cart-popup__close",
                          attrs: {
                            "data-dismiss": "modal",
                            "aria-label": "Close",
                            "aria-hidden": "true"
                          },
                          on: { click: _vm.closePopup }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/views/survey2/images/NCAcmi_close.png"),
                              alt: "닫기"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cart-popup__content payment" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _vm.showConfirmBtn
              ? _c(
                  "div",
                  {
                    staticClass: "cart-popup__item-link",
                    staticStyle: { border: "none" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "bt-akl-blue btn_close NCAcmi_cont03_popup",
                        on: { click: _vm.closePopup }
                      },
                      [_vm._v("확인")]
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a5357a6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a5357a6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyPopupLayer.vue
// module id = null
// module chunks = 